module.exports = __webpack_public_path__ + "static/media/consegna-icon.c09f0ca0.png";